export * from './dynamic-keys.interface';
export * from './generic-dynamic-keys.interface';